import { render } from "./GradeList.vue?vue&type=template&id=a1c30498"
import script from "./js/gradeList.js?vue&type=script&lang=js&external"
export * from "./js/gradeList.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__